import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { AICheckbox } from '../../../AICheckbox'
import { AVATAR_HEIGHT_20 } from '../../../Avatar'
import {
  FormikField,
  getFormikCheckboxFieldErrorProps,
  getFormikCheckboxFieldValueProps,
} from '../../../Formik'
import { ICON_HEIGHT_20 } from '../../../Icon'
import { AILengthDropdownItemContent } from '../../AILengthDropdownItemContent'
import {
  AI_TEXT_GENERATION_FORM_FIELD_NAME_LENGTH,
  AI_TEXT_GENERATION_FORM_FIELD_NAME_PROMPT,
  AI_TEXT_GENERATION_FORM_FIELD_NAME_REMOVE_NOTICE,
  AI_TEXT_GENERATION_FORM_FIELD_NAME_TEMPLATE,
  AI_TEXT_GENERATION_FORM_FIELD_NAME_TONE,
  QA_NAME_AI_TEXT_GENERATION_LENGTH_SELECT,
  QA_NAME_AI_TEXT_GENERATION_REMOVE_NOTICE_CHECKBOX,
  QA_NAME_AI_TEXT_GENERATION_TEMPLATES_SELECT,
  QA_NAME_AI_TEXT_GENERATION_TONE_SELECT,
} from '../../AITextGeneration.constants'
import { AITextGenerationFormikButtonSelect } from '../../AITextGenerationFormikButtonSelect'
import { getAITextGenerationFormFieldsTemplateNextValue } from '../AITextGenerationFormFields.utils'

import * as styles from './AITextGenerationFormFieldsSettings.module.css'

import SpeakerIcon from '../../../../icons/activities/speaker.svg'
import TemplateIcon from '../../../../icons/ai-template.svg'

function AITextGenerationFormFieldsSettings({
  isInteractionDisabled,
  isMobileCompact,
  lengthOptions,
  templates,
  toneOptions,
}) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  function handleSelectTemplate(template) {
    const templateText = template?.raw?.text

    if (templateText) {
      setFieldValue(AI_TEXT_GENERATION_FORM_FIELD_NAME_PROMPT, templateText)
    }
  }

  const settingsClassName = classNames(styles.settings, {
    [styles.settingsDisabled]: isInteractionDisabled,
  })

  return (
    <div className={settingsClassName}>
      <FormikField
        hideControlValue
        Component={AITextGenerationFormikButtonSelect}
        Field={Fragment}
        className={styles.select}
        controlProps={{
          Icon: TemplateIcon,
          placeholder: isMobileCompact
            ? null
            : t('AITextGeneration.TemplatesSelectPlaceholderKey'),
        }}
        getNextValue={getAITextGenerationFormFieldsTemplateNextValue}
        name={AI_TEXT_GENERATION_FORM_FIELD_NAME_TEMPLATE}
        options={templates}
        qaName={QA_NAME_AI_TEXT_GENERATION_TEMPLATES_SELECT}
        onChange={handleSelectTemplate}
      />

      <FormikField
        Component={AITextGenerationFormikButtonSelect}
        Field={Fragment}
        className={styles.select}
        controlProps={{
          Icon: SpeakerIcon,
          defaultValue: toneOptions[0],
          placeholder: isMobileCompact
            ? null
            : t('AITextGeneration.ToneSelectPlaceholderKey'),
        }}
        name={AI_TEXT_GENERATION_FORM_FIELD_NAME_TONE}
        options={toneOptions}
        qaName={QA_NAME_AI_TEXT_GENERATION_TONE_SELECT}
      />

      <FormikField
        Component={AITextGenerationFormikButtonSelect}
        Field={Fragment}
        className={styles.select}
        controlProps={{
          defaultValue: lengthOptions[1],
          placeholder: isMobileCompact
            ? null
            : t('AITextGeneration.LengthSelectPlaceholderKey'),
        }}
        listProps={{
          itemProps: {
            Content: AILengthDropdownItemContent,
            contentProps: {
              avatarProps: {
                avatarClassName: styles.avatar,
                iconSize: ICON_HEIGHT_20,
                size: AVATAR_HEIGHT_20,
              },
            },
          },
        }}
        name={AI_TEXT_GENERATION_FORM_FIELD_NAME_LENGTH}
        options={lengthOptions}
        qaName={QA_NAME_AI_TEXT_GENERATION_LENGTH_SELECT}
      />

      <FormikField
        showTooltip
        Component={AICheckbox}
        Field={Fragment}
        className={styles.checkbox}
        getErrorProps={getFormikCheckboxFieldErrorProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('AITextGeneration.RemoveNoticeCheckboxKey')}
        labelClassName={styles.checkboxLabel}
        labelTitleClassName={styles.checkboxLabelTitle}
        name={AI_TEXT_GENERATION_FORM_FIELD_NAME_REMOVE_NOTICE}
        qaName={QA_NAME_AI_TEXT_GENERATION_REMOVE_NOTICE_CHECKBOX}
      />
    </div>
  )
}

export default AITextGenerationFormFieldsSettings
